import _ from 'lodash';
import TFPACoverablesUtils from './TFPACoverablesUtils';

/**
 * DP2 Term Lookup
 * @type {string[]}
 */
const _DP2_TERM_PUBLICID_LOOKUP = [
  'DPDW_PropertyValuation_HOE',  //Valuation Method
  'zjsg43s5504tobcn94ntoad179b', //Coverage Type
  'zcejevt4l9qn12a6vnmt9l7dp48' //Deductible
];

/**
 * HO3 Homeowner, force optional coverage
 * @param cov
 * @constructor
 */
const HO3OptionalCov = (cov) => {
};

/**
 * HO4 Tenant, force optional coverage
 * @param cov
 * @constructor
 */
const HO4OptionalCov = (cov) => {
};

/**
 * HO6 Condo, force optional coverage
 * @param cov
 * @constructor
 */
const HO6OptionalCov = (cov) => {
};

/**
 * DP2 Dwelling/fire force optoional coverage
 * @param cov
 * @returns {boolean}
 * @constructor
 */
const DP2OptionalCov = (cov) => {
  return cov.publicID === 'DPDW_Personal_Property_HOE';
};

/**
 * HO3 homeowners_tfpa Term check
 * @param cov
 * @param term
 * @param submission
 * @param opts
 * @constructor
 */
const HO3ReadonlyTerm = (cov, term, submission, opts) => {
  if (cov && term) {
    if (cov.publicID === 'HODW_Other_Structures_HOE') {
      return term.patternCode === 'HODW_OtherStructures_Limit_HOE';
    }

    if (cov.publicID === 'HODW_Loss_Of_Use_HOE') {
      return term.patternCode === 'HODW_LossOfUseDwelLimit_HOE';
    }

    // 2026-03-19 - Debra Frum - US31179 - TFPA Homeowner Split Deductible Options
    // Beginning July 2026, users can select TFPA Homeowner Wind or Hail deductible that is different 
    // from Other Peril deductible.
    // When there is only 1 Wind or Hail coverage term deductible option, it will be defaulted 
    // and the field will be read-only.
    // This logic has been implemented in PC EDGE plugins which aligns the TFPA approach with TWIA.
    if (cov.publicID === 'HODW_SectionI_Ded_HOE'
    &&  term.patternCode === 'HODW_WindHail_Ded_HOE') {
      return !term.editable_TWIA;
    }

    if (cov.publicID === 'HOLI_Med_Pay_HOE') {
      return term.patternCode === 'HOLI_MedPay_Limit_HOE' || term.patternCode === 'z29j0l011m5dg4e6homkvm7grv9';
    }

    if (cov.publicID === 'HO400') {
      return term.patternCode === 'HO400Limit';
    }

    if (cov.publicID === 'HODW_Dwelling_Cov_HOE' && term.patternCode === 'HODW_Dwelling_Limit_HOE') {
      const notMH = TFPACoverablesUtils.getConstructionType(submission) !== 'MH_ext';

      return notMH && (!opts || !opts.isPolicyChange);
    }

  }
};

/**
 * HO4 Tenant Term check
 * @param cov
 * @param term
 * @param submission
 * @param opts
 * @constructor
 */
const HO4ReadonlyTerm = (cov, term, submission, opts) => {
  if (cov && term) {
    if (cov.publicID === 'HODW_Loss_Of_Use_HOE') {
      return term.patternCode === 'HODW_LossOfUsePropLimit_HOE';
    }

    if (cov.publicID === 'HODW_SectionI_Ded_HOE') {
      return term.patternCode === 'HODW_HO4_HO6_Ded_HOE';
    }

    if (cov.publicID === 'HOLI_Med_Pay_HOE') {
      return term.patternCode === 'HOLI_MedPay_Limit_HOE' || term.patternCode === 'z29j0l011m5dg4e6homkvm7grv9';
    }

    if (cov.publicID === 'HO401') {
      return term.patternCode === 'HO401Limit';
    }

  }
};

/**
 * HO6 Condo term check
 * @param cov
 * @param term
 * @param submission
 * @param opts
 * @constructor
 */
const HO6ReadonlyTerm = (cov, term, submission, opts) => {
  if (cov && term) {
    if (cov.publicID === 'HODW_Loss_Of_Use_HOE') {
      return term.patternCode === 'HODW_LossOfUsePropLimit_HOE';
    }

    if (cov.publicID === 'HODW_SectionI_Ded_HOE') {
      return term.patternCode === 'HODW_HO4_HO6_Ded_HOE';
    }

    if (cov.publicID === 'HOLI_Med_Pay_HOE') {
      return term.patternCode === 'HOLI_MedPay_Limit_HOE' || term.patternCode === 'z29j0l011m5dg4e6homkvm7grv9';
    }

    if (cov.publicID === 'HO401') {
      return term.patternCode === 'HO401Limit';
    }

  }
};

/**
 * DP1 Dwelling/Fire term check
 * @param cov
 * @param term
 * @param submission
 * @param opts
 * @constructor
 */
const DP2ReadonlyTerm = (cov, term, submission, opts) => {

  // 2025-12-16 - Debra Frum - DE19709 - TFPA - PE : TFPD dwelling deductible value are not getting defaulted
  if (term && !term.editable_TWIA) {
    return true
  }

  // 2025-12-16 - Debra Frum - TODO: I would like the remaining TFPA logic below to be moved to the PC EDGE plugins  
  // which would set term.editable_TWIA = false as was done for the single TFPA scenario that I implemented in DE19709.  
  // The only logic that would remain in this function would be the logic above.  
  // This change would align the TFPA approach with TWIA.

  if (cov && term && cov.publicID === 'DPDW_Dwelling_Cov_HOE') {
    if (term.patternCode === 'zp1gasj244nr336rrf9j13h4fra') {
      return true;
    }

    if (term.patternCode === 'DPDW_Dwelling_Limit_HOE') {
      const notMH = TFPACoverablesUtils.getConstructionType(submission) !== 'MH_ext';
      
      return notMH && (!opts || !opts.isPolicyChange);
    }
  }

  if (cov && term && cov.publicID === 'DPDW_Other_Structures_HOE') {
    return term.patternCode === 'DPDW_OtherStructuresLimit_HOE';
  }

  if (cov && term && cov.publicID === 'DPDW_Personal_Property_HOE') {
    return _.includes(_DP2_TERM_PUBLICID_LOOKUP, term.patternCode);
  }

  if (cov && term && cov.publicID === 'TDP_017') {
    return term.patternCode === 'TotalLimitTDP017';
  }
};

/**
 * Exported functions
 */
export default {
  'HO3': {optionalCov: HO3OptionalCov, readonlyTerm: HO3ReadonlyTerm},
  'HO4': {optionalCov: HO4OptionalCov, readonlyTerm: HO4ReadonlyTerm},
  'HO6': {optionalCov: HO6OptionalCov, readonlyTerm: HO6ReadonlyTerm},
  'DP2': {optionalCov: DP2OptionalCov, readonlyTerm: DP2ReadonlyTerm}
};
